// client/src/routes/app/contracts/$contractId/index.tsx — SCR-CON-003 tab „Termeni" · CON-005.
//
// The layout above has already fetched the contract; `useContract` here is the same query key,
// so react-query serves it from cache rather than issuing a second request. Reading it again
// beats threading it through an Outlet context: each tab states what it needs, and a tab opened
// by direct URL works the same as one reached by clicking.

import { createFileRoute } from '@tanstack/react-router';

import { ErrorState, LoadingState } from '@/components/ui/states';
import { TermsTab } from '@/features/contracts/TermsTab';
import { useContract } from '@/features/contracts/queries';

export const Route = createFileRoute('/app/contracts/$contractId/')({
  component: TermsTabScreen,
});

function TermsTabScreen() {
  const { contractId } = Route.useParams();
  const contract = useContract(contractId);

  if (contract.isPending) return <LoadingState rows={3} />;
  if (contract.isError) return <ErrorState error={contract.error} onRetry={() => void contract.refetch()} />;

  return <TermsTab contract={contract.data} />;
}
